export const socialLinks = {
  instagram: 'http://instagram.com/zhaketcom',
  twitter: 'https://twitter.com/zhaketcom',
  telegram: 'https://t.me/s/zhaketcom',
  linkedin: 'https://linkedin.com/company/zhaket',
};
